import React, { useEffect } from 'react';
import './Toaster.scss'; 
import useToastStore from '../../store/toastStore';

const Toaster = () => {
  const { toast, hideToast } = useToastStore();

  useEffect(() => {
    if (toast.visible) {
      const timer = setTimeout(() => hideToast(), 2000); 
      return () => clearTimeout(timer); 
    }
  }, [toast.visible, hideToast]);

  if (!toast.visible) return null;

  // Title and icon based on severity
  const toastDetails = {
    success: { title: 'Success', icon: '✔️' },
    error: { title: 'Error', icon: '❌' },
    warning: { title: 'Warning', icon: '⚠️' },
    info: { title: 'Info', icon: 'ℹ️' },
  };

  const { title, icon } = toastDetails[toast.severity];

  return (
    <div className={`toast toast-${toast.severity}`}>
      <div className="toast-header">
        <div className='toastIt'>
          <span className="toast-icon">{icon}</span>
          <span className="toast-title">{title}</span>
        </div>
      
        <button className="toast-close" onClick={hideToast}>X</button>
      </div>
      <div className="toast-message">{toast.message}</div>
    </div>
  );
};

export default Toaster;
